import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContractType } from 'client/voladeum/contract-types/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: ContractType[] = EMPTY_ARRAY;

export const contractTypesSlice = createSlice({
  name: SLICE.CONTRACT_TYPES,
  initialState,
  reducers: {
    setContractTypes: (_state, action: PayloadAction<ContractType[]>) => {
      return action.payload;
    },
    clearContractTypes: () => {
      return initialState;
    },
  },
});

export const { setContractTypes, clearContractTypes } = contractTypesSlice.actions;

export default contractTypesSlice.reducer;
